import React from "react";
import IRootContainerProps from "./root-container-props";
import useHomePage from "../hooks/useHomePage";
import AppWindow from "../helpers/app-window";

const appWindow = AppWindow() as any;

function AuthenticatorContainer(props: any) {
  const { goHome } = useHomePage();
  if (!React.isValidElement(props.children)) return null;

  const handleUnauthenticatedUser = () => {
    sessionStorage.clear();
    window.open(appWindow.STUDENT_ENV.REACT_APP_PSS_URL, "_self");
  };

  // set default authData to match current code...
  const authData: any = {
    signInUserSession: {
      accessToken: { payload: { groups: [] } }
    }
  };

  try {
    const imlpToken: any = sessionStorage.getItem("imlpToken");

    let authState = "";
    let authTokenSubject = "";
    let authTokenIsPractice = false;
    let authTokenIsAssignment = false;
    let studentGradeLevel = 0;
    let authTokenExpiry = 0;

    if (imlpToken) {
      const authTokenObj = JSON.parse(atob(imlpToken.split(".")[1]));
      authTokenExpiry = authTokenObj.exp;

      if (authTokenObj.iss.includes("https://identity")) {
        authState = "signedIn";
        authTokenSubject = sessionStorage.getItem("subject") || sessionStorage.getItem("landingSubject") || "";
        if (authTokenSubject === "Purpose") {
          authTokenSubject = "SEL";
        }
        studentGradeLevel = parseInt(sessionStorage.getItem("gradeLevel") || "1", 10);
        authTokenIsAssignment = sessionStorage.getItem("launch")?.toLowerCase() === "assignment";
        authTokenIsPractice = sessionStorage.getItem("launch")?.toLowerCase() === "practice";
        authData.signInUserSession.accessToken.payload.groups.push("Student");
      } else {
        handleUnauthenticatedUser();
      }
    } else if (window.location.hostname !== "localhost") {
      handleUnauthenticatedUser();
    }

    return React.cloneElement(props.children, {
      authState,
      authData,
      studentGradeLevel,
      authTokenSubject,
      authTokenIsAssignment,
      authTokenExpiry,
      authTokenIsPractice
    } as IRootContainerProps);
  } catch (ex) {
    // eslint-disable-next-line
    console.log(ex);
    goHome();
  }

  return null;
}

export default AuthenticatorContainer;
